import { isCustomDisplayTextLabelPart } from '@vista-digital/occ-domain';
export const hasNewline = (label) => {
    if (Array.isArray(label)) {
        return !!label.find(partHasNewLine);
    }
    return partHasNewLine(label);
};
const partHasNewLine = (part) => {
    if (isCustomDisplayTextLabelPart(part)) {
        return part.text.includes('\n');
    }
    return part.includes('\n');
};
//# sourceMappingURL=has-new-line.js.map